import React from "react";
import "../../assets/css/article/ArticleBanner.css";
import { useNavigate } from "react-router-dom";

const ArticleBanner = () => {
  const navigate = useNavigate()
  return (
    <div className="articles_banner">
      <div className="articles_banner_content">
        <h1 style={{fontWeight:"700"}}>C'est le moment de vendre</h1>
        <button className="articles_banner_cta_button" onClick={()=>navigate('/article/creation')}>
          <i className="bi bi-plus-circle-fill" style={{marginRight:"5px"}}></i> Commencer à vendre
        </button>
      </div>
    </div>
  );
};

export default ArticleBanner;